import { QueryFunctionContext } from "react-query"
import { API_PEDIDOS } from "@/utils/pedidos-fetcher"
import { IRegistro, IRegistrosResultado } from "@/interfaces/registros"
import { endPoints } from '@/configs/endPoints'

export async function getRegistrosList(
  ctx: QueryFunctionContext<
    [
      string,
      {
        params: {
          campo: string
          comprimento: number
          direcao: 'asc' | 'desc'
          idEmpregador: string
          inicio: number
          procurar?: string
          dataInicio?: string
          dataFim?: string
        }
      }
    ]
    >
  ): Promise<IRegistrosResultado>{
    const [, { params }] = ctx.queryKey
    const response = await API_PEDIDOS.get<IRegistrosResultado>(
      endPoints.getRegistrosList,
      {
        ...params,
      }
    )

    return response;
  }

  export async function getRegistro(
    ctx: QueryFunctionContext<
      [
        string,
        {
          params: {
            idSolicitacao: string
          }
        }
      ]
    >
  ): Promise<IRegistro> {
    const [, { params }] = ctx.queryKey
    const route = endPoints.getRegistro.replace(
      '{id-solicitacao}',
      params.idSolicitacao
    )
    const data = await API_PEDIDOS.get<IRegistro>(route, {
      ...params
    })
  
    return data
  }
